import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import UserAccessRoot from "@containers/account/access/userAccess/UserAccessRoot";
import {ACCESS_KEYS_VOYAGE_WRITE} from "@containers/account/access/constants/accessList/voyage";
import {BoardsLazy} from "@containers/boards/Boards.lazy";


const BoardsPage = () => {
    return (
        <PageLayout>
            <UserAccessRoot
                accessType={'or'}
                keys={ACCESS_KEYS_VOYAGE_WRITE}
            >
                <Suspense
                    fallback={<SpinnerCustom/>}
                >
                    <BoardsLazy/>
                </Suspense>
            </UserAccessRoot>
        </PageLayout>
    )
};

export default BoardsPage;